import { Checkbox } from 'antd';
import React, { ReactElement } from 'react';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';

const FormSingleCheckbox = (props: any): ReactElement => {
  const formConfig = useGetFormConfig(props);
  const { disabled, onChange, checkboxText} = formConfig;

  return (
    <FormItem formConfig={formConfig} valuePropName="checked">
      <Checkbox
        disabled={disabled}
        onChange={onChange}
      >
        {checkboxText}
      </Checkbox>
    </FormItem>
  );
};
export default FormSingleCheckbox;
